import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true
  },
  {
    id: 1000,
    label: 'MENUITEMS.CARTAPORTE.TEXT',
    icon: 'ri-truck-line',
    isCollapsed: true,
    subItems: [
      {
        id: 1001,
        label: 'MENUITEMS.CARTAPORTE.LIST.DASHBOARD',
        link: '/dashboard/carta-porte',
        parentId: 1000
      },
      {
        id: 1002,
        label: 'MENUITEMS.CARTAPORTE.LIST.NUEVA',
        link: '/carta-porte/emitir',
        parentId: 1000
      },
      {
        id: 1003,
        label: 'MENUITEMS.CARTAPORTE.LIST.HISTORIAL',
        link: '/carta-porte/historial',
        parentId: 1000
      }
    ]
  },
  {
    id: 2,
    label: 'MENUITEMS.CONFIGURACION.TEXT',
    isTitle: true
  },
  {
    id: 2000,
    label: 'MENUITEMS.CUENTA.TEXT',
    icon: 'ri-user-settings-line',
    isCollapsed: true,
    subItems: [
      {
        id: 2001,
        label: 'MENUITEMS.CUENTA.LIST.PERFIL',
        link: '/account/profile',
        parentId: 2000
      },
      {
        id: 2002,
        label: 'MENUITEMS.CUENTA.LIST.EMPRESA',
        link: '/account/empresa',
        parentId: 2000
      },
      {
        id: 2003,
        label: 'MENUITEMS.CUENTA.LIST.FIEL',
        link: '/account/fiel',
        parentId: 2000
      },
      {
        id: 2004,
        label: 'MENUITEMS.CUENTA.LIST.USUARIOS',
        link: '/account/users',
        parentId: 2000
      }
    ]
  }
];
